const profile = {
    name: '姓名',
    avatar: '头像',
    givenName: '名',
    familyName: '姓',
    middleName: '中间名',
    fullname: '全名',
    nickname: '昵称',
    preferredUsername: '首选用户名',
    profile: '个人资料',
    website: '网站',
    gender: '性别',
    birthdate: '出生日期',
    zoneinfo: '时区',
    locale: '语言环境',
    address: {
        formatted: '地址',
        streetAddress: '街道地址',
        locality: '城市',
        region: '州 / 省份',
        postalCode: '邮政编码',
        country: '国家',
    },
    gender_options: {
        female: '女性',
        male: '男性',
        prefer_not_to_say: '不愿透露',
    },
    checkbox_value: {
        checked: '是',
        unchecked: '否',
    },
    avatar_upload: {
        upload: '上传',
        remove: '移除',
        uploading: '上传中...',
        hint: '建议尺寸 1:1，最大 {{limit}}。',
        error_file_type: '文件类型必须为 {{extensions}}。',
        error_file_size: '文件大小不能超过 {{limit}}。',
        error_storage_not_configured: '无法上传照片，请稍后重试。',
        error_upload: '照片上传失败，请重试。',
        error_save: '照片保存失败，请重试。',
        crop_title: '裁剪照片',
        zoom: '缩放',
        error_crop: '图片裁剪失败，请重试。',
    },
};
export default Object.freeze(profile);
